<template>
  <v-container fluid>
    <a name='speaker'></a>
    <h2><a href='#speaker'>Speaker</a></h2>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>

        <v-flex v-for='account in accounts' :key='account.id' xs12 sm6 class='account'>
          <v-layout d-flex justify-center align-center column class='account_container'>
            <a :name='`speaker_${account.id}`'></a>
            <img :src='require(`@/assets/accounts/${account.id}/avatar.${account.imgExtension}`)' class='account_container_avatar'>
            <div class='account_container_name'>
              {{ account.name }}
            </div>
            <div class='account_container_id'>
              <a :href='`https://${account.domain}/@${account.id}`' target='_blank'>
                @{{ account.id }}@{{ account.domain }}
              </a>
            </div>
          </v-layout>
        </v-flex>

        <v-flex xs12 sm6 class='account'>
          <a href='https://connpass.com/event/102622/' target='_blank' class='register'>
            <v-layout d-flex justify-center align-center column class='account_container'>
              <v-icon>add</v-icon>
            </v-layout>
          </a>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'eventguests',
  props: {},
  data: () => {
    return {
      accounts: [
        {
          id: 'tomoki',
          domain: 'vocalodon.net',
          name: 'TOMOKI++',
          content: 'ボカロ丼及びボカロ曲発掘サイト 発掘.jp 運営。',
          imgExtension: 'png'
        },
        {
          id: 'localadms',
          domain: 'social.bluecore.net',
          name: 'ろーかるゆーざー',
          content: 'Social.bluencore.net管理人です。',
          imgExtension: 'gif'
        },
        {
          id: 'toneji',
          domain: 'minohdon.jp',
          name: 'とねぢ@箕面どん',
          content: '箕面どん・管理人です。',
          imgExtension: 'jpg'
        },
        {
          id: 'vaginaplant',
          domain: '3.distn.org',
          name: 'HakabaHitoyo',
          content: '自己認識が直感×アルゴリズム♪になった。',
          imgExtension: 'jpg'
        },
        {
          id: 'guskma',
          domain: 'abyss.fun',
          name: 'ぐすくま',
          imgExtension: 'png'
        }
      ]
    };
  }
}
</script>

<style scoped>
  .account {
    padding: 20px !important;
  }

  .account_container {
    margin: 10px;
    background-color: white;
    padding: 20px 20px;
    width: auto;
    height: 180px;
  }

  .account_container_avatar {
    width: 50px;
    height: 50px;
    border-radius: 10%;
    margin: 5px;
    margin-bottom: 1rem;
    flex: none !important;
  }

  .register {
    text-decoration: none;
  }
</style>
